import {Injectable} from '@angular/core';
import {PageEvent as NgPageEvent} from '@angular/material/paginator';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { IBatch } from '../interfaces/batch';
import { BatchApiService } from './batch-api-service';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import {BehaviorSubject} from 'rxjs';

// @Injectable()
export class BatchDataSource extends ApiDataSource {
  constructor(
    protected BatchApi: BatchApiService,
    private readonly role: string,
    private readonly BatchFilter?: number
  ) {
    super();

    !!this.BatchFilter &&
      Object.keys(this.BatchFilter).forEach(key =>
        this.setFilter(key, this.BatchFilter[key])
      );
  }

  protected Data: BehaviorSubject<IBatch[]> = new BehaviorSubject([]);

  private Batches: IBatch[] = [];

  protected loadData(PageEvent: NgPageEvent) {
    return this.BatchApi.listWithPageEvent(
      this.role,
      this.filter.value,
      PageEvent
    );
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }

  public getRole() {
    return this.role;
  }

  protected setRawData(Batches: any) {
    this.Batches = Batches;

    this.Batches = Batches.map(batch => {
      let headers = [];
      headers = batch.header;

      const {Order: orders} = batch;
      const list = orders.map(order => {
        const status = order.status;
        const {total, itemCount} = order.order_details;
        const {firstName, surname} = order.order_details.billingAddress;
        return {firstName, surname, itemCount, total, status};
      });

      const csvData = orders.map(order => {
        const {firstName, surname} = order.order_details.billingAddress;
        const title = order.order_details.item.title;
        const {total} = order.order_details;
        const account_id = order.account_id;
        return {firstName, surname, title, total, account_id};
      });

      return {...batch, list, csvData, headers};
    });
    this.Data.next(this.Batches);
  }
}
